import Vuex from 'vuex';
import Vue from 'vue';
Vue.use(Vuex);

const state = {
	enabledContents: {
		menu: true,
		reserve: true,
		album: true
	},
	reserved: {
		name: "",
		kana: "",
		phone: "",
		email: "",
		email2: "",
		month: "",
		date: "",
		hour: "",
		minute: "",
		people: "",
		seat: "",
		option: ""
	},
	admin: {
		account: ""
	},
	operator: {
		headerBar: false,
		headerTitle: "",
		sideMenu: false
	}
};

const actions = {};
const getters = {
	enabledContents: (state) => { return state.enabledContents; },
	reserved: (state) => { return state.reserved; },
	admin: (state) => { return state.admin; },
	operator: (state) => { return state.operator; }
};
const mutations = {
	enabledContents_menu(state, payload) {
		state.enabledContents.menu = payload;
	},
	enabledContents_reserve(state, payload) {
		state.enabledContents.reserve = payload;
	},
	enabledContents_album(state, payload) {
		state.enabledContents.album = payload;
	},
	reserved_name(state, payload) {
		state.reserved.name = payload;
	},
	reserved_kana(state, payload) {
		state.reserved.kana = payload;
	},
	reserved_phone(state, payload) {
		state.reserved.phone = payload;
	},
	reserved_email(state, payload) {
		state.reserved.email = payload;
	},
	reserved_email2(state, payload) {
		state.reserved.email2 = payload;
	},
	reserved_month(state, payload) {
		state.reserved.month = payload;
	},
	reserved_date(state, payload) {
		state.reserved.date = payload;
	},
	reserved_hour(state, payload) {
		state.reserved.hour = payload;
	},
	reserved_minute(state, payload) {
		state.reserved.minute = payload;
	},
	reserved_people(state, payload) {
		state.reserved.people = payload;
	},
	reserved_seat(state, payload) {
		state.reserved.seat = payload;
	},
	reserved_option(state, payload) {
		state.reserved.option = payload;
	},
	admin_account(state, payload) {
		state.admin.account = payload;
	},
	operator_headerBar(state, payload) {
		state.operator.headerBar = payload;
	},
	operator_headerTitle(state, payload) {
		state.operator.headerTitle = payload;
	},
	operator_sideMenu(state, payload) {
		state.operator.sideMenu = payload;
	}
};

export default new Vuex.Store({
	state,
	getters,
	actions,
	mutations
});



// WEBPACK FOOTER //
// ./src/vuex/store.js